import axiosInstanceNew from "../lib/axiosinstanceNew";

const NoticeModel = class {
 
  async Addnotice(data) {
       
    return await axiosInstanceNew.post("notification",data);
}
};

export default new NoticeModel();

